import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-resend-success',
  templateUrl: './resend-success.component.html',
  styleUrls: ['./resend-success.component.scss'],
})
export class ResendSuccessComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
